module.exports = __webpack_public_path__ + "static/media/ki.4f47a3db.svg";